import React, { Component } from 'react';
import 'scss/components/_prizes.scss';

class Prizes extends Component {
  render() {
    const populatedFields = [
      !!this.props.page.content.contentFields.prize1Title,
      !!this.props.page.content.contentFields.prize2Title,
      !!this.props.page.content.contentFields.prize3Title,
    ].filter(x => x).length;

    return (
      <div className={`thunderbolt__page prizes prizes-count-${populatedFields}`}>
        <div className="content-page">
          <h1>{this.props.page.content.contentFields.title}</h1>
          <div className="prize-card-container">
            {this.props.page.content.contentFields.prize1Title && (
              <div className="prize-card">
                <img src={this.props.page.content.contentFields.prize1Image} />
                <div className="prize-card-content">
                  <h2>{this.props.page.content.contentFields.prize1Title}</h2>
                  <p>{this.props.page.content.contentFields.prize1Text}</p>
                </div>
              </div>
            )}
            {this.props.page.content.contentFields.prize2Title && (
              <div className="prize-card">
                <img src={this.props.page.content.contentFields.prize2Image} />
                <div className="prize-card-content">
                  <h2>{this.props.page.content.contentFields.prize2Title}</h2>
                  <p>{this.props.page.content.contentFields.prize2Text}</p>
                </div>
              </div>
            )}
            {this.props.page.content.contentFields.prize3Title && (
              <div className="prize-card">
                <img src={this.props.page.content.contentFields.prize3Image} />
                <div className="prize-card-content">
                  <h2>{this.props.page.content.contentFields.prize3Title}</h2>
                  <p>{this.props.page.content.contentFields.prize3Text}</p>
                </div>
              </div>
            )}
          </div>
          {this.props.page.content.contentFields.footerButtonText && (
            <div className="prize-card-footer">
              <a
                href={this.props.page.content.contentFields.footerButtonLink}
                className="thunderbolt-button thunderbolt-button--large"
              >
                {this.props.page.content.contentFields.footerButtonText}
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Prizes;
